import { attr, belongsTo, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Cart = ApplicationRecord.extend({
  static: {
    jsonapiType: 'carts',
  },
  attrs: {
    email: attr(),
    apiTax: attr({ persist: false }),
    subtotal: attr({ persist: false }),
    apiTotal: attr({ persist: false }),
    shipping: attr({ persist: false }),
    plainSubtotal: attr({ persist: false }),
    subtotalWithoutCoupon: attr({ persist: false }),
    shoobId: attr(),
    zipCode: attr(),
    cartType: attr(),
    couponId: attr(),
    schoolId: attr(),
    messageId: attr(),
    couponValue: attr({ persist: false }),
    from: attr(),
    createdLocation: attr(),
    price: attr({ persist: false }),
    cartId: attr({ persist: false }),
    processed: attr({ persist: false }),
    purchased: attr({ persist: false }),
    idSupplied: attr({ persist: false }),
    qualifiesForFreeAnnouncements: attr({ persist: false }),
    school: belongsTo(),
    coupon: belongsTo(),
    orderPackages: hasMany(),
    orders: hasMany(),
  }
});

export default Cart;
